import React, { useState } from 'react';
import QtyControl from './QtyControl';
import { fmtBRL, getGenerated, ITEM_LABELS } from './utils';
import styles from './Calculator.module.css';

const BED_TYPES = [
  { id: 'solteiro', label: 'Solteiro' },
  { id: 'queen', label: 'Queen' },
  { id: 'king', label: 'King' },
  { id: 'superking', label: 'Superking' },
];

const MODES = [
  ['locacao', 'Locacao'],
  ['lavanderia', 'Lavanderia'],
  ['ambos', 'Ambos'],
];

export default function Calculator({ getPrice }) {
  const [mode, setMode] = useState('locacao');
  const [hospedes, setHospedes] = useState(0);
  const [banheiros, setBanheiros] = useState(0);
  const [quartos, setQuartos] = useState(0);
  const [beds, setBeds] = useState({ solteiro: 0, queen: 0, king: 0, superking: 0 });

  const changeBed = (type, val) =>
    setBeds(prev => ({ ...prev, [type]: Math.max(0, val) }));

  const generated = getGenerated({ hospedes, banheiros, quartos, beds });

  let locTotal = 0;
  let lavTotal = 0;
  Object.entries(generated).forEach(([id, qty]) => {
    const loc = getPrice(id, 'locacao');
    const lav = getPrice(id, 'lavanderia');
    locTotal += qty * loc;
    lavTotal += qty * lav;
  });

  const grand =
    mode === 'locacao' ? locTotal :
    mode === 'lavanderia' ? lavTotal :
    locTotal + lavTotal;

  const resetAll = () => {
    setHospedes(0);
    setBanheiros(0);
    setQuartos(0);
    setBeds({ solteiro: 0, queen: 0, king: 0, superking: 0 });
  };

  return (
    <div className={styles.calculator}>
      <div className={styles.topBar}>
        <div>
          <div className={styles.kicker}>Modo de calculo</div>
          <div className={styles.modeToggle}>
            {MODES.map(([key, label]) => (
              <button
                key={key}
                className={`${styles.modeBtn} ${mode === key ? styles.active : ''}`}
                onClick={() => setMode(key)}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <button className={styles.resetBtn} onClick={resetAll}>Limpar</button>
      </div>

      <div className={styles.inputGrid}>
        <InputCard
          code="H"
          title="Hospedes"
          sub="1 fronha + 1 toalha de banho por hospede"
          value={hospedes}
          onChange={setHospedes}
        />
        <InputCard
          code="B"
          title="Banheiros"
          sub="1 toalha de rosto + 1 piso por banheiro"
          value={banheiros}
          onChange={setBanheiros}
        />
        <InputCard
          code="Q"
          title="Quartos"
          sub="1 toalha de piscina + 1 manta por quarto"
          value={quartos}
          onChange={setQuartos}
        />
        <div className={styles.infoCard}>
          <span className={styles.infoLabel}>Camas</span>
          <strong>2 lencois</strong>
          <span>por cama cadastrada</span>
        </div>
      </div>

      <div className={styles.workspace}>
        <section className={styles.bedSection}>
          <div className={styles.sectionHeader}>
            <div>
              <div className={styles.sectionEyebrow}>Composicao</div>
              <h2 className={styles.sectionTitle}>Camas</h2>
            </div>
            <span className={styles.sectionBadge}>2 lencois/cama</span>
          </div>
          <div className={styles.bedRows}>
            {BED_TYPES.map(({ id, label }) => (
              <div key={id} className={styles.bedRow}>
                <span className={styles.bedLabel}>{label}</span>
                <QtyControl size="sm" value={beds[id]} onChange={v => changeBed(id, v)} />
                <span className={styles.bedResult}>{beds[id] * 2} lencois</span>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.generated}>
          <div className={styles.sectionHeader}>
            <div>
              <div className={styles.sectionEyebrow}>Saida</div>
              <h2 className={styles.sectionTitle}>Itens gerados</h2>
            </div>
          </div>
          <div className={styles.genRows}>
            {Object.entries(generated).map(([id, qty]) => {
              const price = getPrice(id, mode);
              const total = qty * price;
              return (
                <div key={id} className={`${styles.genRow} ${qty === 0 ? styles.zero : ''}`}>
                  <span>{ITEM_LABELS[id]}</span>
                  <span className={styles.genQty}>{qty}x {fmtBRL(price)}</span>
                  <span className={styles.genTotal}>{total > 0 ? fmtBRL(total) : '-'}</span>
                </div>
              );
            })}
          </div>
        </section>
      </div>

      <section className={styles.summary}>
        <div className={styles.summaryTitle}>Resumo financeiro</div>
        {(mode === 'locacao' || mode === 'ambos') && (
          <div className={styles.summaryRow}>
            <span>Subtotal locacao</span>
            <span>{fmtBRL(locTotal)}</span>
          </div>
        )}
        {(mode === 'lavanderia' || mode === 'ambos') && (
          <div className={styles.summaryRow}>
            <span>Subtotal lavanderia</span>
            <span>{fmtBRL(lavTotal)}</span>
          </div>
        )}
        <div className={`${styles.summaryRow} ${styles.total}`}>
          <span>Total</span>
          <span>{fmtBRL(grand)}</span>
        </div>
      </section>
    </div>
  );
}

function InputCard({ code, title, sub, value, onChange }) {
  return (
    <div className={styles.inputCard}>
      <div className={styles.inputCardHeader}>
        <span className={styles.inputIcon}>{code}</span>
        <div>
          <div className={styles.inputCardTitle}>{title}</div>
          <div className={styles.inputCardSub}>{sub}</div>
        </div>
      </div>
      <QtyControl value={value} onChange={onChange} />
    </div>
  );
}
